import React from 'react';
import ReactDOM from 'react-dom/client';
// import { BrowserRouter } from 'react-router-dom';  // Import BrowserRouter
import App from './App';  // Import App component
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* <BrowserRouter>  */}
      <App />
    {/* </BrowserRouter> */}
  </React.StrictMode>
);

reportWebVitals();
